import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const pdfs = ref<string[]>([])
export const useDevicePDFsStore = defineStore('devicePDFs', () => {
  const setToPDFsStore = (data: string[]) => {
    pdfs.value = data
  }
  const addToPDFsStore = (data: string[]) => {
    pdfs.value.push(...data)
  }
  const removeFromPDFsStore = (remove: string[]) => {
    pdfs.value = pdfs.value.filter((pdf) => !remove.includes(pdf))
  }
  const getPDFs = computed(() => {
    return pdfs.value
  })
  const resetStoreState = () => {
    pdfs.value = []
  }

  return {
    setToPDFsStore,
    addToPDFsStore,
    removeFromPDFsStore,
    getPDFs,
    resetStoreState,
  }
})
